import React, { Component } from 'react';
//import { FormControl, FormGroup, Button } from 'react-bootstrap';
import Helmet from 'react-helmet';

import Hero from './content/Hero';
import Feature from './content/Feature';
import LastCall from './content/LastCall';
import Footer from './content/Footer';
import WebfineryNavbar from './WebfineryNavbar';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import mixpanel from "mixpanel-browser";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router";

import Newsletter from './Newsletter.js';

import './content/content.css';

import InnerFeature from "./content/InnerFeature";

import ContactModal from './ContactModal';


class CloudPage extends Component {

	constructor() {
		super();

		this.state = {
			contactModalVisible: false, fa: "", 
			contactModalTopic: "", 
			contactModalCue: "",
			contactModalPush: "",
			messageInputCollapsed: true
		};

		this.mixpanel = mixpanel;
		this.apiButtons = this.apiButtons.bind(this);
		this.searchButton = this.searchButton.bind(this);
		this.visitRankButton = this.visitRankButton.bind(this);
		this.consultingButton = this.consultingButton.bind(this);
		this.handleHideContactModal = this.handleHideContactModal.bind(this);
		this.handleUseItYourSelfClick = this.handleUseItYourSelfClick.bind(this);
		this.handleContactUsClick = this.handleContactUsClick.bind(this);
		this.handleContactUsApiClick = this.handleContactUsApiClick.bind(this);
		this.visitRankButtons = this.visitRankButtons.bind(this);
	}

	componentDidMount () {
	  window.scrollTo(0, 0);
	}

	handleUseItYourSelfClick() {
		this.setState({contactModalVisible: true, fa: "fa-bolt", contactModalTopic: "Webfinery Crawler", 
			contactModalCue: "Crawl millions of websites on demand",
			contactModalPush: "",
			messageInputCollapsed: true
		});
	}

	handleContactUsClick() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery Cloud Services", 
			contactModalCue: "Contact us",
			contactModalPush: "",
			messageInputCollapsed: false
		});
	}

	handleContactUsApiClick() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery Cloud APIs", 
			contactModalCue: "Please describe your use case",
			contactModalPush: "",
			messageInputCollapsed: false
		});
	}		

	handleHideContactModal() {
		this.setState({contactModalVisible: false});
	}

	cloudHeroContent() {
		return (
			<div>
				<h1>Webfinery Cloud Services</h1>
		        <h2>Build new apps, add value to existing ones</h2>
				<h3>Discover and automatically assess every website</h3>
				<div>
					<Button bsSize="lg" bsStyle="success" onClick={this.handleContactUsClick}>Contact us</Button>
					<a href="#cloud" className="btn btn-default btn-lg">Learn more</a>    				
				</div>
			</div>
		)
	}

	apiButtons(topic, optionalButton) {
		return (
			<div>
				<div style={{float: 'right', marginTop: '15px'}}>
					{optionalButton}
		  			<Button bsSize="sm" onClick={this.handleContactUsApiClick}>Contact us</Button>
				</div>
			</div>
		)
	}

	visitRankButtons() {		
		return (
			<div>
				<div style={{float: 'right', marginTop: '15px'}}>
					{this.visitRankButton()}
					<LinkContainer to="/cloud/visitrank">
		  				<Button bsSize="sm">API docs &amp; pricing</Button>
		  			</LinkContainer>
				</div>
			</div>
		)
	}	

	searchButton() {
		return (
			<LinkContainer to='/search'>
  				<Button bsStyle="success" bsSize="small">See it in action</Button>
  			</LinkContainer>
		)
	}

	visitRankButton() {
		return (
			<a className="btn btn-success btn-sm" href="https://www.visitrank.com/" target="_blank">See it in action</a>
		)
	}

	consultingButton() {
		return (
			<LinkContainer to='/consulting'>
				<Button bsStyle="success" bsSize="small">Learn more</Button>
			</LinkContainer>
		)
	}

  render() {
    return (
      <div className="Services">
      	<Helmet title="APIs &amp; Cloud Services" />
      	<WebfineryNavbar/>      	
      	
      	<Hero>
      		{this.cloudHeroContent()}
      	</Hero>

      	<div id="cloud">

      		<Feature shade={true}>
      			<h3>Crawl</h3>				
  				<div className={'benefit inner-benefit'}>
  					<h5><i className="fa fa-bolt fa-3x" aria-hidden="true"></i></h5>
  					<h4>Webfinery Crawler</h4>  					
  					<h5 style={{fontWeight: 'bold'}}>Crawl millions of websites</h5>
  					<Grid>
  						<Row>
  							<Col md={12}>  								
  								<p>Blazing fast, massively scalable, fully configurable cloud-based crawler.<br /> 
  								Built to crawl millions of web pages a day without harming the hosts.<br />
  								No programming skills required.<br />
  								</p>
  								<h5 style={{fontWeight: 'bold'}}>Run it yourself or leave it to us</h5>
								<div>
									<div style={{margin: '20px'}}>				
										<Button bsStyle="success" onClick={this.handleUseItYourSelfClick}>Use it yourself</Button>
							  			<Link to="/consulting" className="btn btn-default">Managed by us</Link>
									</div>
								</div>
  							</Col>
  						</Row>
  					</Grid>					
				</div>

      		</Feature>

	      	<Feature innerFeatureList={true} shade={true} h3="Develop">
	      		<InnerFeature label="Visit Rank API">
	      			Get a website matching a given rank, get a rank for a given website, get top 10k, 100k, 1M, 10M, 100M web domains or any given rank range
	      			{this.visitRankButtons()}
	      		</InnerFeature>
	      		<InnerFeature label="Geolocation API">Reveal the city, region, country, network, organization name and more. Use it to personalize your users' experience. {this.apiButtons('Geo Location API')}</InnerFeature>
	      		<InnerFeature label="Categories API">
					Get the main and secondary categories for a given website: travel, ecommerce, insurance, SaaS, news, and many more.
					{this.apiButtons('Categories API')}
	      		</InnerFeature>
	      		<InnerFeature label="Tags API">Get up to 10 best matching tags for a website {this.apiButtons('Tags API')}</InnerFeature>
	      		<InnerFeature label="Similar Sites API">Get list of websites similar to a given website {this.apiButtons('Similar Websites API')}</InnerFeature>
	      		<InnerFeature label="Links API"> Find backlinks and outlinks for a given website {this.apiButtons('Links API')}</InnerFeature>
	      		<InnerFeature label="Monitor API">Periodically monitor a given website for HTTP Status code changes or changes in the content of the monitored website {this.apiButtons('Monitor API')}</InnerFeature>
	      		<InnerFeature label="Screenshots API">
					Take a screenshot of any website, instantly get a ready-to-serve link to the created screenshot
					{this.apiButtons('Screeshots API')}
	      		</InnerFeature>
	      		<InnerFeature label="Source Search API">
	      			Discover websites by pattern matching against JavaScript, HTML code and HTTP Headers, title, meta tags and/or keywords
	      			{this.apiButtons('Source Search API', this.searchButton())}
	      		</InnerFeature>
	      		<InnerFeature label="Meta Search API">
	      			Target and discover websites by combining rank ranges, categories, tags, keywords, backlinks and/or outlinks
	      			{this.apiButtons('Meta Search API')}
	      		</InnerFeature>
	      		<InnerFeature label="AI Classifier API">
	      		 	Leverage machine learning to discover and classify websites matching your specific criteria
	      		 	{this.apiButtons('AI Classifier API')}
	      		</InnerFeature>
	      		<InnerFeature label="Crawl API">
	      			One-off or scheduled fully configurable crawler on demand. Transform and enrich crawled data using Webfinery and third-party APIs.
	      			{this.apiButtons('Crawl API', this.consultingButton())}
	      		</InnerFeature>      		
	      	</Feature>

	      	<LastCall>
	      		<Newsletter/>
	      	</LastCall>
	    </div>
      	<Footer/>
		<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
    				contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
    				visible={this.state.contactModalVisible} handleHide={this.handleHideContactModal} 
    				submittedLabel={this.state.contactModalSubmittedLabel} messageInputCollapsed={this.state.messageInputCollapsed}/>      	
      </div>
     );
	}
}

export default CloudPage;



// WEBPACK FOOTER //
// ./src/CloudPage.js